/**
 * 连通性测试（T15）。
 *
 * 用当前表单值经 `createProviderAdapter()` 实例化适配器并调用 `listModels()`：
 * - 成功返回模型列表；
 * - 失败返回规范化后的错误码 + 消息；
 * - **不落库、不写密钥**，纯只读探测（临时 key 只在这次调用里传递）。
 */
import type { ProviderDeps, ResolvedProviderConfig } from '../../core/providers';
import { normalizeProviderError } from './errors';
import type { NormalizedProviderError } from './errors';
import { ensureBuiltinProviderKinds } from './registrySetup';
import { modelGateway } from '../modelGateway';

export type ConnectionResult =
  | { ok: true; models: string[] }
  | { ok: false; error: NormalizedProviderError };

/** 探测一次连通性；deps 仅测试注入（真实页面用默认 fetch）。 */
export async function testProviderConnection(
  config: ResolvedProviderConfig,
  deps?: ProviderDeps,
): Promise<ConnectionResult> {
  ensureBuiltinProviderKinds();
  try {
    const adapter = modelGateway.createChatAdapter(config, deps);
    const models = await adapter.listModels();
    return { ok: true, models };
  } catch (error) {
    return { ok: false, error: normalizeProviderError(error) };
  }
}
